import { Component, OnInit } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import * as moment from 'moment-timezone';
import { CompanyService } from 'src/app/services/core/company/company.service';
import { FundingSourceService } from 'src/app/services/core/funding-source/funding-source.service';
import { SharedDataService } from 'src/app/services/app/shared-service/shared-data.service';
import { ManualPaymentService } from 'src/app/services/core/manual-payment/manual-payment.service';
import { NUMBER_OF_RECORDS } from 'src/app/utils/common.utils';

@UntilDestroy()
@Component({
  selector: 'app-manuals-list',
  templateUrl: './manuals-list.component.html',
  styleUrls: ['./manuals-list.component.css']
})
export class ManualsListComponent implements OnInit {
  manuals: any = [];
  totalResults = 0;
  totalPages = 0;
  currentPage = 1;
  numberOfRecords = NUMBER_OF_RECORDS;
  relationType: string = '';
  paymentType: string = '';
  company: any = '';
  fundingSource: any = '';
  timeZone: any = moment.tz.guess();
  todayDate: any = [moment().startOf('day'), moment().endOf('day')];
  companies: any = [];
  fundingSources: any = [];
  loading = false;

  constructor(
    private manualPaymentService: ManualPaymentService,
    private companyService: CompanyService,
    private fundingSourceService: FundingSourceService,
    private sharedDataService: SharedDataService
  ) { }

  ngOnInit() {
    this.sharedDataService.getUser().pipe(untilDestroyed(this)).subscribe((data) => {
      if (data && data.timeZone) {
        this.timeZone = data.timeZone;
        this.todayDate = [moment().tz(this.timeZone).startOf('day'), moment().tz(this.timeZone).endOf('day')];
      }
    });
    this.getManuals(this.currentPage);

    this.companyService.getPickerCompanies({ limit: 9999, isActive: true })
      .pipe(untilDestroyed(this)).subscribe((data: any) => {
        if (data && data.results) {
          this.companies = data.results;
        }
      });
    this.fundingSourceService.getPicker({ limit: 9999, isActive: true })
      .pipe(untilDestroyed(this)).subscribe((data: any) => {
        if (data && data.results) {
          this.fundingSources = data.results;
        }
      });
  }

  getManuals(page: number) {
    let queryparams: any = {
      limit: this.numberOfRecords,
      page,
      sortBy: 'createdAt:desc'
    }

    if (this.relationType) {
      queryparams['relationType'] = this.relationType;
    }
    if (this.paymentType) {
      queryparams['paymentType'] = this.paymentType;
    }
    if (this.company && this.relationType !== 'fundingsource') {
      queryparams['company'] = this.company;
    }
    if (this.fundingSource && this.relationType !== 'vendor') {
      queryparams['fundingSource'] = this.fundingSource;
    }
    queryparams['time'] = [this.todayDate[0].toISOString(), this.todayDate[1].toISOString()];

    this.loading = true;
    this.manualPaymentService
      .getAll(queryparams)
      .pipe(untilDestroyed(this)).subscribe({
        next: (data: any) => {
          this.loading = false;
          if (data && data.results) {
            this.manuals = data.results;
            this.totalPages = data.totalPages;
            this.totalResults = data.totalResults;
          }
        },
        error: () => {
          this.loading = false;
        }
      });
  }

  onPageChange(page: number) {
    this.currentPage = page;
    this.getManuals(page);
  }

  onSelectRelation() {
    this.currentPage = 1;
    this.getManuals(this.currentPage);
  }

  onFilterChange() {
    this.currentPage = 1;
    this.getManuals(this.currentPage);
  }

  onDateChange(event: any) {
    if (event[0] && event[1]) {
      this.todayDate = [event[0], event[1].endOf('day')];
      this.currentPage = 1;
      this.getManuals(this.currentPage);
    }
  }
}
